<template>
  <div v-if="$route.name === 'Room'" class="floors-map-category">
    <h4
      v-show="!($root.isTmall && floor._slug.indexOf('0') > -1)"
      v-for="(floor, index) in $root.floors"
      :key="index"
      :class="[
        { 'regular': currentFloor !== floor._slug },
        { 'selected': currentFloor === floor._slug }
      ]"
      @click="onClick(floor)"
      class="pointer inline-block pt-1 mr-4 mx-md-4"
    >
      {{floor[$route.params.language + 'Title']}}
    </h4>
  </div>
</template>

<script>

export default {
  data () {
    return {
      currentFloor: ''
    }
  },

  mounted () {
    this.currentFloor = this.$route.params.floor
  },

  methods: {
    onClick (floor) {
      this.$emit('onFloorClick', floor._slug)
      this.currentFloor = floor._slug
    }
  },

  watch: {
    $route () {
      this.currentFloor = this.$route.params.floor
    }
  }
}
</script>

<style lang="scss" scoped>
.floors-map-category {
  position: absolute;
  top: 44px;
  left: 50%;
  transform: translateX(-50%);

  @include breakpoint('sm-and-down') {
    position: relative;
    top: 0;
    left: 0;
    transform: none;
    margin-top: 80px;
    margin-bottom: 30px;
    text-align: center;
  }
}

h4 {
  color: $c-black;
  cursor: pointer;
  opacity: 0.4;
  transition: opacity  0.25s;
  display: inline-block;

  &:hover {
    opacity: 1;
  }

  &.selected {
    opacity: 1;
    font-size: 22px;
  }
}

</style>
